import { formatDateTimeRange } from '@op/components/FilterCommon/utils/time';
import {
  getTimelineTimeFormat,
  normalizeOpinionDateType,
} from './getTimelineTimeFormat';
import type { IEventClusterRequestParams } from '@/pages/intelligence/services/eventCluster';

export interface IBuildEventClusterParamsOptions {
  gameIds: string[];
  startTime: string;
  endTime: string;
  dateType?: string;
}

export function buildEventClusterParams(
  options: IBuildEventClusterParamsOptions,
): IEventClusterRequestParams {
  const { gameIds, startTime, endTime, dateType } = options;
  const normalizedDateType = normalizeOpinionDateType(dateType);
  const { start_time, end_time } = formatDateTimeRange(
    startTime,
    endTime,
    normalizedDateType,
  );

  return {
    start_date: start_time.slice(0, 10),
    end_date: end_time.slice(0, 10),
    game_ids: gameIds,
  };
}

/** @deprecated 保留旧导出名，实际构建 event_cluster 请求参数 */
export function buildOpinionTimelineParams(
  options: IBuildEventClusterParamsOptions,
): IEventClusterRequestParams {
  return buildEventClusterParams(options);
}

export function getTimelineFormatByParams(
  params: { date_type?: string },
): string {
  return getTimelineTimeFormat(params.date_type);
}
